var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('color-text-btn',{staticClass:"filter-item line menu-btn-item",attrs:{"type":_vm.isEdit ? 'danger' : 'info',"size":"mini"},on:{"click":_vm.to}},[_vm._v(" "+_vm._s(_vm.isEdit ? '更新' : '上传')+"位置psd ")])}
var staticRenderFns = []

export { render, staticRenderFns }